import { z } from 'zod'

export default function refineDateValidation(startDateField: string, endDateField: string) {
  return (data: Record<string, any>, ctx: z.RefinementCtx) => {
    if (data[endDateField] < data[startDateField]) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data final não pode ser inferior à data inicial',
        path: [endDateField]
      })
    }

    if (data[startDateField] > data[endDateField]) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data inicial não pode ser superior à data final',
        path: [startDateField]
      })
    }

    // Validação 3: Data inicial deve ser maior ou igual a 1900
    if (data[startDateField].getFullYear() < 1900) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data mínima inicial é 1900',
        path: [startDateField]
      })
    }

    // Validação 4: Data final deve ser maior ou igual a 1900
    if (data[endDateField].getFullYear() < 1900) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data mínima final é 1900',
        path: [endDateField]
      })
    }

    // Validação 5: Data inicial não pode ser superior a 100 anos a partir da data atual
    const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100))
    if (data[startDateField] > maxDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data inicial não pode ser superior a 100 anos a partir da data atual',
        path: [startDateField]
      })
    }

    // Validação 6: Data final não pode ser superior a 100 anos a partir da data atual
    if (data[endDateField] > maxDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data final não pode ser superior a 100 anos a partir da data atual',
        path: [endDateField]
      })
    }
  }
}
